module.exports = __webpack_public_path__ + "static/media/developer-logotype-l.38197536.svg";